import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserInfoForm from './components/UserInfoForm';
import DocumentUpload from './components/DocumentUpload';
import ThankYou from './components/ThankYou';
import Logo from './components/Logo';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="app-header">
          <div className="header-content">
            <Logo size="large" />
            <div className="header-text">
              <h1>Commitment Scan & GO</h1>
              <p className="header-subtitle">High Point Market Documentation System</p>
            </div>
          </div>
        </header>
        <main className="app-main">
          <Routes>
            <Route path="/" element={<UserInfoForm />} />
            <Route path="/upload" element={<DocumentUpload />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
